function isPushSupported() {
  return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Must be called directly inside a user gesture (e.g. a button tap) — iOS/WebKit
// silently refuses to show the native permission dialog otherwise. Returns
// the eventual permission decision so the caller can await it before
// checking Notification.permission elsewhere — a fast login response can
// resolve before the user has actually tapped Allow/Don't Allow on the
// still-visible native dialog, so reading Notification.permission
// immediately after login would incorrectly see 'default' and skip
// subscribing even though the user grants it a moment later.
export function requestNotificationPermission() {
  if (!isPushSupported()) return Promise.resolve('denied');
  if (Notification.permission !== 'default') return Promise.resolve(Notification.permission);
  return Notification.requestPermission().catch((err) => {
    console.error('❌ Error solicitando permiso de notificaciones:', err);
    return 'denied';
  });
}

// Safe to call any time after login (permission may already be granted from a
// previous session). Registers the service worker and syncs the subscription
// with the backend; no-ops quietly if unsupported or not yet permitted.
export async function registerAndSubscribe() {
  if (!isPushSupported() || Notification.permission !== 'granted') return;

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      const res = await fetch('/api/push/vapid-public-key');
      const { publicKey } = await res.json();
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    await fetch('/api/push/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(subscription.toJSON()),
    });
  } catch (err) {
    console.error('❌ Error al suscribirse a notificaciones push:', err);
  }
}
